import { IBitfApiCallState } from '@interfaces';
import { BitfApiCallStateMapper } from '@bitf/core/api-call-state/bitf-api-call-state.mapper';
import { EBitfApiRequestPartsNames } from '@enums';

export class BitfGraphQlApiCallStateMapper extends BitfApiCallStateMapper {
  buildApiRequest(apiCallState: IBitfApiCallState): void {
    this.assignApiRequestValuesAsArray(apiCallState, EBitfApiRequestPartsNames.SORTING);

    this.assignApiRequestValuesAsArray(apiCallState, EBitfApiRequestPartsNames.SEARCH);

    this.assignApiRequestValuesAsArray(apiCallState, EBitfApiRequestPartsNames.FILTER);
  }
}
